import { Button } from "semantic-ui-react";
import Countdown from "react-countdown";

function BotaoComTimer({ onClick }) {
  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      return (
        <p style={{ textAlign: "center" }}>
          <Button className="btn-link" type="button" onClick={onClick}>
            Enviar novamente o e-mail
          </Button>
        </p>
      );
    } else {
      return (
        <div style={{ textAlign: "center", margin: "20px 0" }}>
          <small>Você pode solicitar novo e-mail em {seconds} segundos </small>
        </div>
      );
    }
  };
  return (
    <>
      <Countdown renderer={renderer} date={Date.now() + 59000} />
    </>
  );
}

export default BotaoComTimer;
